// they are placed in orders
export enum APPLICATION_STATUS_MODULE {
  APPLICATION_SUMMARY = 'applicationSummary',
  APPLICATION = 'application',
  APPLICATION_FEE_PAYMENT = 'applicationFeePayment',
  ACADEMIC_REFEREE_STATUS = 'academicRefereeStatus',
  SUPERVISOR_INVITATION = 'supervisorInvitation',
  RETURN_REMARKS = 'returnRemarks',
  OFFER = 'offer',
  OFFER_STATUS = 'offerStatus',
  CONFIRM_OFFER = 'confirmOffer',
  DEBIT_NOTE = 'debitNote',
  REGISTRATION_PREPARATION = 'registrationPreparation',
  VISA_APPLICATION = 'visaApplication',
  CONDITIONAL_OFFER_CONFIRMATION = 'conditionalOfferConfirmation',
  QUALIFICATION_CHECK = 'qualificationCheck',
  TUITION_FEE_PAYMENT = 'tuitionFeePayment',
  REGISTRATION = 'onlineRegistration',
}

export enum APPLICATION_TODO_LIST {
  APPLICATION_FEE = 'APPLICATION_FEE',
  ACADEMIC_REFEREE = 'ACADEMIC_REFEREE',
  OFFER_ACCEPTANCE = 'OFFER_ACCEPTANCE',
  REJECTION_INFORMATION = 'REJECTION_INFORMATION',
  REGISTRATION_FEE = 'REGISTRATION_FEE',
  VISA_APPLICATION = 'VISA_APPLICATION',
  QUALIFICATION_CHECK = 'QUALIFICATION_CHECK',
  MEET_CONDITION = 'MEET_CONDITION',
  REGISTRATION = 'REGISTRATION',
  ONLINE_REGISTRATION = 'ONLINE_REGISTRATION',
  SUPERVISOR_INVITATION = 'SUPERVISOR_INVITATION',
  RETURN_REMARKS = 'RETURN_REMARKS',
  TUITION_FEE = 'TUITION_FEE',
}

export enum APPLICATION_STATUS_MODULE_MAP {
  APPLICATION_SUMMARY = 'APPLICATION_SUMMARY',
  APPLICATION = 'APPLICATION',
  APPLICATION_FEE_PAYMENT = APPLICATION_TODO_LIST.APPLICATION_FEE,
  ACADEMIC_REFEREE_STATUS = APPLICATION_TODO_LIST.ACADEMIC_REFEREE,
  SUPERVISOR_INVITATION = APPLICATION_TODO_LIST.SUPERVISOR_INVITATION,
  RETURN_REMARKS = APPLICATION_TODO_LIST.RETURN_REMARKS,

  OFFER = 'OFFER',
  OFFER_STATUS = 'OFFER_STATUS',
  CONFIRM_OFFER = 'CONFIRM_OFFER',

  DEBIT_NOTE = APPLICATION_TODO_LIST.REGISTRATION_FEE,
  REGISTRATION_PREPARATION = 'REGISTRATION_PREPARATION',
  VISA_APPLICATION = APPLICATION_TODO_LIST.VISA_APPLICATION,
  CONDITIONAL_OFFER_CONFIRMATION = APPLICATION_TODO_LIST.MEET_CONDITION,
  QUALIFICATION_CHECK = APPLICATION_TODO_LIST.QUALIFICATION_CHECK,

  REGISTRATION = APPLICATION_TODO_LIST.REGISTRATION,
  TUITION_FEE_PAYMENT = APPLICATION_TODO_LIST.TUITION_FEE,
}

export enum MERIDIEM_TYPE {
  AM = 'AM',
  PM = 'PM',
}
